import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { AddEditPurchasePartyComponent } from './addEditPurchaseParty.component';

import { PurchasePartyModel } from '../../../model/index';
import { PurchasePartyService } from '../../../services/index';

@Component({
    selector: 'purchase-party-tab',
    templateUrl: './purchaseParty.component.html',
})
export class PurchasePartyMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    //@Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public purListData: any[] = [];

    isLoadMask: Promise<any>;
    referenceData: PurchasePartyModel[];
    isLoading: boolean = false;
    filterData = {
        "search_data": ""
    };
    constructor(private purchasePartyService: PurchasePartyService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'party_name',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Name', prop: 'party_name', cellClass: 'cell-left', width: 380, minWidth: 380, maxWidth: 380 },
            { name: 'Action', prop: 'sno', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getPurchasePartyList();
        }
    }

    /**
   * Called whenever the user changes the sort order
   */
    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
        // there will always be one "sort" object if "sortType" is set to "single"
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy = sortInfo.sorts[0].prop;
        this.getPurchasePartyList();
    }
    onScroll() {
        this.suppressPaging = true;

        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }

        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);

    }
    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getPurchasePartyList();
    }
    clearFilter(): void {
        this.filterData = {
            "search_data": ""
        };
        this.applyFilter();
    }

    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getPurchasePartyList();
    }
    getPurchasePartyList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };
        let that = this;
        this.isLoadMask = this.purchasePartyService
            .getPurchasePartyList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.purListData = res.data;
            });
    }

    bsModalRef: BsModalRef;
    public onAddEditParty(mode: string, row: any): void {
        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);
        this.bsModalRef = this.modalService.show(AddEditPurchasePartyComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Purchase Party Details';
        this.bsModalRef.content.purParData = Object.assign({}, row);
        this.bsModalRef.content.purchasePartyLoadEvent.subscribe(($e) => {
            that.getPurchasePartyList();
        });
    }

    onDeleteParty(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover Purchase Party: ' + row.name + ' Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.purchasePartyService
                .deletePurchaseParty(row.ref_id)
                .then(function(res: any) {
                    if (res.success) {
                        that.getPurchasePartyList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }

                });
        }, function(dismiss) {

        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/purchaseParty/purchaseParty.component.ts